/* eslint-disable replo/no-tailwind-literal-color */
import type { OpencodeEvent } from "schemas/opencode";

import * as React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { ScrollToBottomButton } from "@v2/features/agent-debugger/tabs/ScrollToBottomButton";
import { StickToBottom } from "use-stick-to-bottom";

const EventsContent: React.FC<{
  events: { timestamp: number; event: OpencodeEvent }[];
  onClearEvents: () => void;
}> = ({ events, onClearEvents }) => {
  return (
    <StickToBottom.Content className="flex flex-col text-xs">
      {events.length === 0 ? (
        <span className="text-xs text-slate-400">No events received yet</span>
      ) : (
        <div className="space-y-1.5">
          {events.map((entry, i) => (
            <div
              key={`${entry.timestamp}-${i}`}
              className="rounded bg-slate-50 p-2"
            >
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold text-slate-600">
                  {entry.event.type}
                </span>
                <span className="text-xs text-slate-400">
                  {new Date(entry.timestamp).toLocaleTimeString()}
                </span>
              </div>
              <pre className="mt-1 max-h-[150px] overflow-auto whitespace-pre-wrap break-words text-xs text-slate-500">
                {JSON.stringify(entry.event, null, 2)}
              </pre>
            </div>
          ))}
        </div>
      )}
      {events.length > 0 && (
        <Button
          variant="secondary"
          size="sm"
          UNSAFE_className="mt-2 self-start"
          onClick={onClearEvents}
        >
          Clear events
        </Button>
      )}
    </StickToBottom.Content>
  );
};

const EventsTab: React.FC<{
  events: { timestamp: number; event: OpencodeEvent }[];
  onClearEvents: () => void;
}> = ({ events, onClearEvents }) => {
  return (
    <StickToBottom className="relative min-h-0 flex-1 overflow-auto">
      <EventsContent events={events} onClearEvents={onClearEvents} />
      <ScrollToBottomButton />
    </StickToBottom>
  );
};

export { EventsTab };
